export default {
  meta: {
    title: '机会点详情',
    parentPath: ['/car'],
    url: '/car/chance', // 埋点用，记录所属模块
    breadcrumbs: {
      path: ['/car/chance'],
      name: ['机会点管理'],
    },
  },
};
